import { Component, OnInit } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SettingsService } from '../../core/settings/settings.service';

@Component({
    selector: '[app-footer]',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    versioneBackend: string;

    // HttpClient senza interceptor: la versione è informativa, un errore non deve mostrare popup
    private http: HttpClient;

    constructor(public settings: SettingsService, httpBackend: HttpBackend) {
        this.http = new HttpClient(httpBackend);
    }

    ngOnInit() {

        this.http.get(environment.restBaseUrl + '/Versione', { responseType: 'text' }).subscribe({
            next: versione => this.versioneBackend = versione?.trim(),
            error: () => this.versioneBackend = null
        });

    }

}
